import { useState } from "react";
import { t } from "i18next";

import { ModalExplainMedidas } from "@/shared/components/organisms/ModalExplainMedidas";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { InputTextRight } from "@/shared/components/atoms/InputTextRight";
import { ButtonPrimary } from "@/shared/components/atoms/ButtonPrimary";
import { ToggleText } from "@/shared/components/organisms/ToggleText";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { InputFile } from "@/shared/components/atoms/InputFile";
import { Select } from "@/shared/components/organisms/Select";

export type PersonalInformationNutritionPageProps = any;

export const PersonalInformationNutritionPage = () => {
  const optionSex = [
    { id: 0, name: t("assisteds.controller.select_assisted") },
    { id: 1, name: t("user.views.male") },
    { id: 2, name: t("user.views.female") },
  ];
  const [selectSex, setSelectSex] = useState(optionSex[0]);
  //FUMADOR
  const [fumador, setFumador] = useState(false);
  //SLEEPWELL
  const [sleepwell, setSleepwell] = useState(false);
  //MEDICATION
  const [medication, setMedication] = useState(false);
  //MEDICALPROBLEM
  const [medicalProblem, setMedicalProblem] = useState(false);
  //LASTANALYTIC
  const [lastAnalytic, setLastAnalytic] = useState(false);
  //ALTEREDTENSION
  const [alteredTension, setAlteredTension] = useState(false);
  //AFECTPERIOD
  const [afectPeriod, setAfectPeriod] = useState(false);
  //amenorrea
  const [amenorrea, setAmenorrea] = useState(false);
  //PERIODIRREGULAR
  const [periodIrregular, setPeriodIrregular] = useState(false);
  //SERIOUS INJURES
  const [seriousInjures, setSeriousInjures] = useState(false);
  //INJURES
  const [ankle, setAnkle] = useState(false);
  const [knee, setKnee] = useState(false);
  const [hip, setHip] = useState(false);
  const [lumbar, setLumbar] = useState(false);
  const [cervical, setCervical] = useState(false);
  const [deltoid, setDeltoid] = useState(false);
  //FINAL INJURES

  //actividadFisica
  const [actividadFisica, setActividadFisica] = useState(false);
  //INTOLERANCE
  const [intolerance, setIntolerance] = useState(false);
  //SUPLEMENTATION
  const [suplementation, setSuplementation] = useState(false);
  //USE SUPLEMENTATION
  const [useSuplementation, setUseSuplementation] = useState(false);
  //OPTIONS OBJECTIVE
  const optionsObjective = [
    { id: 0, name: t("assisteds.controller.select_assisted") },
    { id: 1, name: t("progress.objective.healt") },
    { id: 2, name: t("progress.objective.definition") },
    { id: 3, name: t("progress.objective.hypertrophy") },
    { id: 3, name: t("progress.objective.performance") },
  ];
  const [selectObjective, setSelectObjective] = useState(optionsObjective[0]);
  //MODAL EXPLAIN MEDIDAS
  const [modalExplainMedidas, setModalExplainMedidas] = useState(false);
  const handleOpenModalExplainMedidas = () => {
    setModalExplainMedidas(!modalExplainMedidas);
  };
  //OPEN DIALOG CREATE
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const functionOpenDialogCreate = () => setOpenDialogCreate(!openDialogCreate);

  return (
    <>
      <nav className="bg-white border-gray-200 px-4 py-2.5 rounded shadow-md">
        <div className="container flex flex-wrap items-center justify-between mx-auto">
          <div className="flex items-center">
            <img
              src="https://dash.fitmewise.com/uploads/branchs/default.png"
              className="h-20 mr-3"
              alt="Logo"
            />
            <span className="self-center text-xl font-semibold whitespace-normal text-gray-700">
              FILIAL 3 DEMON GYM
            </span>
          </div>
        </div>
      </nav>
      <div className="mx-0 sm:mx-auto w-full sm:w-3/4 h-full px-4 sm:px-0">
        <div className="mt-6 pb-10">
          <div className="space-y-4">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.general_info")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <Select
                    name="sex"
                    selected={selectSex}
                    setSelected={setSelectSex}
                    options={optionSex}
                    tittle={t("user.views.sex")}
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("user.views.birthday")}
                    type="date"
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("user.views.phone")}
                    type="tel"
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("user.views.occupation")}
                    type="text"
                  />
                </div>
                <div className="col-span-full">
                  <Select
                    name="objective"
                    tittle={t("user.views.objective")}
                    selected={selectObjective}
                    setSelected={setSelectObjective}
                    options={optionsObjective}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.meditions_user")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.height")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.weight")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="kg" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full border-b border-gray-900/10 pb-4">
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.measure")}{" "}
                    <span
                      onClick={handleOpenModalExplainMedidas}
                      className="text-sm leading-6 text-gray-400 cursor-pointer"
                    >
                      {t("user.views.know_measure")}
                    </span>
                  </h2>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.arm")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.neck")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.waist")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.hip")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.leg")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.chest")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.shoulder")}
                    </h2>
                    <div className="w-[80px]">
                      <InputTextRight label="" spanRight="cm" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.images_progess")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <ButtonSoft
                    text={t("user.views.progress_image")}
                    size="extraLarge"
                    onClick={functionOpenDialogCreate}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.healt_title")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.smoker")}
                    </h2>
                    <ToggleText
                      texto={fumador ? t("general.yes") : t("general.no")}
                      checked={fumador}
                      onChange={setFumador}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.hours_sleep")}
                    </h2>
                    <div className="w-[80px]">
                      <InputWithCornerHint label="" type="text" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.sleep_well")}
                    </h2>
                    <ToggleText
                      texto={sleepwell ? t("general.yes") : t("general.no")}
                      checked={sleepwell}
                      onChange={setSleepwell}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.medication")}
                    </h2>
                    <ToggleText
                      texto={medication ? t("general.yes") : t("general.no")}
                      checked={medication}
                      onChange={setMedication}
                    />
                  </div>
                </div>
                {medication && (
                  <div className="col-span-full">
                    <TextArea label="" />
                  </div>
                )}
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.medical_problem")}
                    </h2>
                    <ToggleText
                      texto={
                        medicalProblem ? t("general.yes") : t("general.no")
                      }
                      checked={medicalProblem}
                      onChange={setMedicalProblem}
                    />
                  </div>
                </div>
                {medicalProblem && (
                  <div className="col-span-full">
                    <TextArea label="" />
                  </div>
                )}
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.last_analytic_altered")}
                    </h2>
                    <ToggleText
                      texto={lastAnalytic ? t("general.yes") : t("general.no")}
                      checked={lastAnalytic}
                      onChange={setLastAnalytic}
                    />
                  </div>
                </div>
                {lastAnalytic && (
                  <div className="col-span-full">
                    <TextArea label="" />
                  </div>
                )}
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.altered_tension")}
                    </h2>
                    <ToggleText
                      texto={
                        alteredTension ? t("general.yes") : t("general.no")
                      }
                      checked={alteredTension}
                      onChange={setAlteredTension}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.affects_period")}
                    </h2>
                    <ToggleText
                      texto={afectPeriod ? t("general.yes") : t("general.no")}
                      checked={afectPeriod}
                      onChange={setAfectPeriod}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.amenorrea")}
                    </h2>
                    <ToggleText
                      texto={amenorrea ? t("general.yes") : t("general.no")}
                      checked={amenorrea}
                      onChange={setAmenorrea}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.irregular_period")}
                    </h2>
                    <ToggleText
                      texto={
                        periodIrregular ? t("general.yes") : t("general.no")
                      }
                      checked={periodIrregular}
                      onChange={setPeriodIrregular}
                    />
                  </div>
                </div>
                {periodIrregular && (
                  <div className="col-span-full">
                    <TextArea
                      label={t("user.views.irregular_period_frequency")}
                    />
                  </div>
                )}
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.serious_injuries")}
                    </h2>
                    <ToggleText
                      texto={
                        seriousInjures ? t("general.yes") : t("general.no")
                      }
                      checked={seriousInjures}
                      onChange={setSeriousInjures}
                    />
                  </div>
                </div>
                {seriousInjures && (
                  <div className="col-span-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-x-5">
                      <div className="grid grid-cols-1">
                        <div className="flex items-center justify-between mt-5 gap-x-5">
                          <h1 className="text-base leading-6 text-gray-900">
                            {t("user.views.ankle")}
                          </h1>
                          <div className="flex justify-end">
                            <ToggleText
                              checked={ankle}
                              onChange={setAnkle}
                              texto={ankle ? t("general.yes") : t("general.no")}
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-5 gap-x-5">
                          <h1 className="text-base leading-6 text-gray-900">
                            {t("user.views.knee")}
                          </h1>
                          <div className="flex justify-end">
                            <ToggleText
                              checked={knee}
                              onChange={setKnee}
                              texto={knee ? t("general.yes") : t("general.no")}
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-5 gap-x-5">
                          <h1 className="text-base leading-6 text-gray-900">
                            {t("user.views.hip")}
                          </h1>
                          <div className="flex justify-end">
                            <ToggleText
                              checked={hip}
                              onChange={setHip}
                              texto={hip ? t("general.yes") : t("general.no")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1">
                        <div className="flex items-center justify-between mt-5 gap-x-5">
                          <h1 className="text-base leading-6 text-gray-900">
                            {t("user.views.lumbar")}
                          </h1>
                          <div className="flex justify-end">
                            <ToggleText
                              checked={lumbar}
                              onChange={setLumbar}
                              texto={
                                lumbar ? t("general.yes") : t("general.no")
                              }
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-5 gap-x-5">
                          <h1 className="text-base leading-6 text-gray-900">
                            {t("user.views.cervical")}
                          </h1>
                          <div className="flex justify-end">
                            <ToggleText
                              checked={cervical}
                              onChange={setCervical}
                              texto={
                                cervical ? t("general.yes") : t("general.no")
                              }
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-5 gap-x-5">
                          <h1 className="text-base leading-6 text-gray-900">
                            {t("user.views.deltoid")}
                          </h1>
                          <div className="flex justify-end">
                            <ToggleText
                              checked={deltoid}
                              onChange={setDeltoid}
                              texto={
                                deltoid ? t("general.yes") : t("general.no")
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <InputWithCornerHint label={t("user.views.other")} />
                    </div>
                  </div>
                )}
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.sitting_hours")}
                    </h2>
                    <div className="w-[80px]">
                      <InputWithCornerHint label="" type="text" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.physical_activity")}
                    </h2>
                    <ToggleText
                      texto={
                        actividadFisica ? t("general.yes") : t("general.no")
                      }
                      checked={actividadFisica}
                      onChange={setActividadFisica}
                    />
                  </div>
                </div>
                {actividadFisica && (
                  <div className="col-span-full">
                    <TextArea label={""} />
                  </div>
                )}
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.days_week_train")}
                    </h2>
                    <div className="w-[80px]">
                      <InputWithCornerHint label="" type="number" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <h2 className="text-base leading-7 text-gray-900">
                    {t("user.views.training_experience")}
                  </h2>
                  <TextArea label="" />
                </div>
                <div className="col-span-full">
                  <h2 className="text-base leading-7 text-gray-900">
                    {t("user.views.training_with_trainer")}
                  </h2>
                  <TextArea label="" />
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.usual_training_time")}
                    </h2>
                    <div className="w-[80px]">
                      <InputWithCornerHint label="" type="number" />
                    </div>
                  </div>
                </div>
                <div className="col-span-full">
                  <h2 className="text-base leading-7 text-gray-900">
                    {t("user.views.foods_not_like")}
                  </h2>
                  <TextArea label="" />
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.intolerance")}
                    </h2>
                    <ToggleText
                      texto={intolerance ? t("general.yes") : t("general.no")}
                      checked={intolerance}
                      onChange={setIntolerance}
                    />
                  </div>
                </div>
                {intolerance && (
                  <div className="col-span-full">
                    <TextArea label={""} />
                  </div>
                )}
                <div className="col-span-full">
                  <h2 className="text-base leading-7 text-gray-900">
                    {t("user.views.food_preferences")}
                  </h2>
                  <TextArea label="" />
                </div>
                <div className="col-span-full">
                  <h2 className="text-base leading-7 text-gray-900">
                    {t("user.views.how_may_meal_day")}
                  </h2>
                  <TextArea label="" />
                </div>
                <div className="col-span-full">
                  <h2 className="text-base leading-7 text-gray-900">
                    {t("user.views.meals_in_home_and_outside")}
                  </h2>
                  <TextArea label="" />
                </div>
                <div className="col-span-full">
                  <h2 className="text-base leading-7 text-gray-900">
                    {t("user.views.foods_in_home_and_outside")}
                  </h2>
                  <TextArea label="" />
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.supplementation")}
                    </h2>
                    <ToggleText
                      texto={
                        suplementation ? t("general.yes") : t("general.no")
                      }
                      checked={suplementation}
                      onChange={setSuplementation}
                    />
                  </div>
                </div>
                {suplementation && (
                  <div className="col-span-full">
                    <TextArea label={""} />
                  </div>
                )}
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.would_use_supplementation")}
                    </h2>
                    <ToggleText
                      texto={
                        useSuplementation ? t("general.yes") : t("general.no")
                      }
                      checked={useSuplementation}
                      onChange={setUseSuplementation}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <TextArea label={t("user.views.9")} />
                </div>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <ButtonPrimary
                text={t("chat.app.send")}
                size="large"
                onClick={() => {}}
              />
            </div>
          </div>
        </div>
      </div>
      <ModalExplainMedidas
        open={modalExplainMedidas}
        Close={handleOpenModalExplainMedidas}
        tittleModal={t("user.views.measure")}
      >
        <div className="flex flex-items-center justify-center">
          <img
            src="https://dash.fitmewise.com/images/measures/measures_es.png"
            alt=""
            className="w-[60vh]  h-[50vh] sm:h-[70vh]"
          />
        </div>
      </ModalExplainMedidas>
      <DialogCreate
        open={openDialogCreate}
        setOpen={setOpenDialogCreate}
        tittle={t("user.views.up_image_progress")}
        tittleButtonCreate={t("general.save")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={functionOpenDialogCreate}
      >
        <div className="mt-5">
          <InputFile
            name="imagen"
            id="imagen"
            label={""}
            spanButton={t("general.up_image")}
            description={t("general.format_image")}
            selectedImage={""}
            onFileChange={() => {}}
            onRemoveImage={() => {}}
            tittleDelete={t("gym.views.delete_image")}
          />
        </div>
      </DialogCreate>
    </>
  );
};
